import { CircularProgress } from "@mui/material"
// import Logo from "./logos/logo-4.png"
import { assetsUrl } from "../../constants";
const SplashScreen = ()=>{
    return (
      <div className="flex flex-col gap-5 justify-center items-center w-full h-[100dvh]">
      <img src={`${assetsUrl}/logos/logo-4.png`}  width={130}/>
      <CircularProgress size={35} />
  </div>
    )
  }

export default SplashScreen